<template>
  <!-- absolute after permanent menu not fixed-->
    <v-navigation-drawer app permanent    dark v-model="drawer"
    :temporary="$vuetify.breakpoint.xsOnly"
    :class="{ 'width-100': $vuetify.breakpoint.xsOnly }"
    style="height: 100% !important;max-height: calc(100%) !important;"
     :mini-variant="isMini"
    @mouseenter.native="onMouseEnter"
    @mouseleave.native="onMouseLeave">
      <!-- <router-link to="/" exact>
        <img src="@/assets/logo.png" alt="" width="100%" class="pa-5" />
      </router-link> -->

      <!-- shaped rounded-->
      <v-list >
       <!-- <h2 class="pl-2" v-bind:style="{ color:'#4680FF'}">MENUS</h2>  -->
        <v-list-item-group v-model="selectedMenu" mandatory color="primary">
          <v-list-item
            class="tile"
            v-for="([icon, text, route], i) in menus"
            :key="i"
            link
            @click="onClickMenu(route)"
          >
            <v-list-item-icon>
              <v-icon color="#5B6B79" :class="{ 'active-icon': selectedMenu === i }">{{ icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <!-- v-bind:style="{fontWeight:'500 !important' }" -->
              <v-list-item-title >{{ text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
</template>

<script>
import { feature } from "../../services/constants";
import { lg_menu } from "../../views/language/lg_menu";
import api from "@/services/api";

export default {
  name: "Menu",
  props: [],


  async mounted() {
    const result = await api.getAccountById(localStorage.getItem("user_id"));

    localStorage.getItem(feature.LANGUAGE) === "th"
      ? (this.lg_menu = lg_menu.menu_th)
      : (this.lg_menu = lg_menu.menu_en);

    if (result.data.role == "Admin") {
      this.menus = this.lg_menu.menus_admin;
    } else if (result.data.role == "Company Admin") {
      this.menus = this.lg_menu.menus_company_admin;
    } else if (result.data.role == "Member") {
      this.menus = this.lg_menu.menus_member;
    } else {
      this.menus = this.lg_menu.menus_guest;
    }

    if (this.selectedMenu != -1) {
      this.selectedMenu = this.menus.findIndex(
        (menu) => menu[2] == this.$route.path
      );
    }
  },
  data() {
    return {
      menus: null,
      selectedMenu: 0,
      oldselectedMenu:0,
      drawer: true,
      miniByUser: true,
      hovered: false, 
    };
  },

  computed: {
    isMini() {
      if (this.$vuetify.breakpoint.xsOnly) return false;
      return this.miniByUser && !this.hovered;
    },
  },

  methods: {
    onClickMenu(link) {
      if(this.$vuetify.breakpoint.xsOnly) {
        this.$store.state.navMenu = false;
      }
      this.$router.push(link).catch(() => {});
    },
    onMouseEnter() {
      if (!this.$vuetify.breakpoint.xsOnly) {
        this.hovered = true;
      }
    },
    onMouseLeave() {
      this.hovered = false;
    },

    // เรียกจาก Header เพื่อ toggle
    toggleMini() {
      this.miniByUser = !this.miniByUser;
    },
  },
  watch: {
    $route(to) {
      this.oldselectedMenu = this.selectedMenu;
      this.selectedMenu = this.menus.findIndex((menu) => menu[2] == to.path);
      if (this.selectedMenu === -1) {
        this.selectedMenu = this.oldselectedMenu;
      }
    },
  },
};
</script>

<style>
.v-list-item-group .v-list-item--active {
  /* color: #467FFF !important;
  font-weight: bold; */
    color: #467FFF !important;
  font-weight: bold;
  background-color: transparent !important;
}

.v-list-item--active::before {
  opacity: 0 !important;
}

.theme--dark.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  opacity: 0.7;
  color: #000000;
}

.tile {
  color: #000000;
  
}
.tile:hover {
  /* background: #078fc3; */
  /* color: #000000 !important; */
}
.tile:active {
  background: #078fc3;
}
.width-100{
  width:100% !important;
}

.v-navigation-drawer__content{
  background: #F8F9FA;
}
.theme--dark.v-subheader {
    color:#215295;
}

.active-icon {
   color: #467FFF !important;
}

/* .v-list--rounded .v-list-item, .v-list--rounded .v-list-item::before, .v-list--rounded .v-list-item > .v-ripple__container {
    border-radius: 8px !important;
} */
</style>
